module.exports = __webpack_public_path__ + "img/detailsCard-not-img.90ded76c.png";